import { concantQuery } from "@/utils/concatQuery";
import api from "./api";

/**
 * Get blogs.
 * @param {*} param0
 * @returns
 */
const postDataToMarketplace = ({ data }) => {
  return api.post(`/marketplaces`, data);
};

function addMarketplaceItemPhoto(formData) {
  debugger
  return api({
    method: 'post',
    url: `/marketplaces/add-car-photo`,
    data: formData,
  })
}

function deleteCarPhoto({ imageId }) {
  return api.delete(`/marketplaces/delete-car-photo/${imageId}`)
}

const editDataByIdMarketplace = ({ carId, formData }) => {
  return api.put(`/marketplaces/${carId}`, formData);
};

const getDataToMarketplace = ({ take, skip, search, all, status }) => {
  const query = concantQuery({ take, skip, search, all, status });
  return api.get(`/marketplaces${query}`);
};
const getDataByIdToMarketplace = ({ id }) => {
  return api.get(`/marketplaces/${id}`);
};

const changeStatus = ({ data }) => {
  return api.put(`/marketplaces/change-status`, data);
};

const getStates = () => {
  return api.get(`/marketplaces/states`);
};

export {
  postDataToMarketplace,
  getDataToMarketplace,
  changeStatus,
  getDataByIdToMarketplace,
  editDataByIdMarketplace,
  addMarketplaceItemPhoto,
  deleteCarPhoto,
  getStates
};
